// Textos da Conferência da folha e do Custo de folha (01/11/2026), coletados por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'dp.folha.titulo': 'Conferência da folha',
    'dp.folha.aba.conferencia': 'Conferência',
    'dp.folha.aba.custo': 'Custo de folha',
    'dp.folha.explica': 'O DP manda a folha pela tela de Arquivos, as regras comparam com o que o Hub sabe e só o que diverge vira alerta. Corrija no Protheus e rode de novo, ou justifique aqui. Fechar registra o que foi conferido e por quem. Médias de férias, décimo terceiro e aviso continuam manuais em Rotinas da folha.',
    'dp.folha.kpi.aberto': 'Alertas abertos',
    'dp.folha.kpi.justificado': 'Justificados',
    'dp.folha.kpi.resolvido': 'Resolvidos',
    'dp.folha.kpi.semVerbas': 'Regras sem verba',
    'dp.folha.rodar': 'Rodar regras',
    'dp.folha.rodou': 'Regras rodadas: {{novos}} novos, {{resolvidos}} resolvidos, {{reabertos}} reabertos.',
    'dp.folha.fecharDica': 'Fecha a conferência com o registro de quem fechou. {{n}} alertas abertos ficam registrados como estão.',
    'dp.folha.semFolha': 'A folha de {{rotulo}} não está no Hub. Mande o arquivo pela tela de Arquivos.',
    'dp.folha.abrirArquivos': 'Abrir Arquivos',
    'dp.folha.filiaisSemFolha': 'Sem folha neste período, e fora das regras: {{filiais}}.',
    'dp.folha.folhaMudou': 'A folha foi importada depois da última rodada. Rode as regras de novo.',
    'dp.folha.fechada': 'Fechada por {{quem}} em {{quando}}, com {{abertos}} alertas abertos e {{justificados}} justificados.',
    'dp.folha.sistema': 'sistema',
    'dp.folha.naoRodou': 'As regras desta competência ainda não rodaram.',
    'dp.folha.todasComVerbas': 'Todas as regras têm verba configurada.',
    'dp.folha.configurar': 'Configurar',
    'dp.folha.semVerbasDica': 'Faltam os códigos de verba nos parâmetros. Até lá, a regra não dá alerta.',
    'dp.folha.parcialDica': 'A regra roda em parte: faltam alguns códigos de verba nos parâmetros.',
    'dp.folha.semVerbasSemKey': 'Falta configurar',
    'dp.folha.abertoUm': '1 aberto',
    'dp.folha.abertos': '{{n}} abertos',
    'dp.folha.conferidoUm': '1 conferido',
    'dp.folha.conferidos': '{{n}} conferidos',
    'dp.folha.contagemDaRegra': '{{justificados}} justificados, {{resolvidos}} resolvidos',
    'dp.folha.quadroDaFilial': '{{filial}}, quadro {{quadro}}, folha {{folha}}',
    'dp.folha.por': 'Por {{quem}}',
    'dp.folha.semPessoa': 'Sem pessoa',
    'dp.folha.valorOculto': 'Oculto',
    'dp.folha.valorOcultoDica': 'O valor só aparece para quem vê dado sensível do DP',
    'dp.folha.justificar': 'Justificar',
    'dp.folha.editarJustificativa': 'Editar a justificativa',
    'dp.folha.reabrir': 'Reabrir o alerta',
    'dp.folha.justificativa': 'Justificativa',
    'dp.folha.justificarTitulo': 'Justificar o alerta de {{nome}}',
    'dp.folha.justificarExplica': 'A justificativa fica no alerta, sobrevive às próximas rodadas e não vai para a trilha de auditoria. Não escreva motivo de saúde.',
    'dp.folha.col.pessoa': 'Pessoa',
    'dp.folha.col.regra': 'Regra',
    'dp.folha.col.esperado': 'Esperado',
    'dp.folha.col.naFolha': 'Na folha',
    'dp.folha.col.diferenca': 'Diferença',
    'dp.folha.col.situacao': 'Situação',
    'dp.folha.col.acoes': 'Ações',
    'dp.folha.situacao.aberto': 'Aberto',
    'dp.folha.situacao.justificado': 'Justificado',
    'dp.folha.situacao.resolvido': 'Resolvido',
    'dp.folha.situacaoRegra.ok': 'Sem alerta',
    'dp.folha.situacaoRegra.alertas': 'Com alerta',
    'dp.folha.situacaoRegra.sem_verbas': 'Verbas não configuradas',
    'dp.folha.situacaoRegra.sem_folha': 'Sem folha',
    'dp.folha.situacaoRegra.sem_base': 'Sem base',
    'dp.folha.situacaoRegra.nao_rodada': 'Não rodou',
    'dp.folha.regra.verba_proibida': 'Verba que não pode estar na folha',
    'dp.folha.regra.adiantamento': 'Adiantamento com o desconto correspondente',
    'dp.folha.regra.coparticipacao': 'Coparticipação igual à da operadora',
    'dp.folha.regra.horas_extras': 'Horas extras iguais às da jornada',
    'dp.folha.regra.afastados_desligados': 'Demitidos, afastados e quem voltou',
    'dp.folha.regra.quadro': 'Quem está na folha e quem está no quadro',
    'dp.folha.regra.bonus_adicionais': 'Bônus e adicionais iguais à apuração',
    'dp.folha.regra.descontos_administrativos': 'Descontos de multa e de sinistro',
    'dp.folha.regra.custo_medio': 'Custo dentro da média',
    'dp.folha.esperado.verba_proibida': 'Ninguém com a verba',
    'dp.folha.esperado.adiantamento': 'O crédito igual ao débito, por pessoa',
    'dp.folha.esperado.coparticipacao': 'A fatura do mês no Plano de saúde',
    'dp.folha.esperado.horas_extras': 'A jornada da competência, de 16 a 15',
    'dp.folha.esperado.afastados_desligados': 'A demissão e as Ausências',
    'dp.folha.esperado.quadro': 'A base de ativos do Protheus',
    'dp.folha.esperado.bonus_adicionais': 'A apuração em Bônus e adicionais',
    'dp.folha.esperado.descontos_administrativos': 'Multas e Sinistros do motorista',
    'dp.folha.esperado.custo_medio': 'A média dos três períodos anteriores',
    'dp.folha.detalhe.adiantamento': 'Adiantamento',
    'dp.folha.detalhe.coparticipacao': 'Coparticipação',
    'dp.folha.detalhe.he50': 'Horas extras 50%',
    'dp.folha.detalhe.he100': 'Horas extras 100%',
    'dp.folha.detalhe.demitido': 'Demitido antes do período, com salário',
    'dp.folha.detalhe.afastado': 'Afastado o período inteiro, com salário',
    'dp.folha.detalhe.voltou': 'Voltou ao trabalho, sem salário',
    'dp.folha.detalhe.semProvento': 'No quadro, sem provento na folha',
    'dp.folha.detalhe.foraDoQuadro': 'Na folha, fora do quadro',
    'dp.folha.detalhe.operador_hectare': 'Bônus do operador',
    'dp.folha.detalhe.adicional_prancha': 'Adicional de prancha',
    'dp.folha.detalhe.adicional_sinistro': 'Adicional de sinistro',
    'dp.folha.detalhe.adicional_manobra': 'Adicional de manobra',
    'dp.folha.detalhe.adicional_eixos': 'Adicional de eixos',
    'dp.folha.detalhe.descontoMulta': 'Desconto de multa',
    'dp.folha.detalhe.descontoSinistro': 'Desconto de sinistro',
    'dp.folha.detalhe.semFuncao': 'Sem função',
    'dp.folha.custo.proventos': 'Proventos',
    'dp.folha.custo.pessoas': 'Pessoas com provento',
    'dp.folha.custo.medio': 'Custo médio',
    'dp.folha.custo.mediaAnterior': 'Média dos três anteriores',
    'dp.folha.custo.desvio': 'Desvio',
    'dp.folha.custo.situacao': 'Situação',
    'dp.folha.custo.foraDaMedia': 'Fora da média',
    'dp.folha.custo.semMedia': 'Sem média',
    'dp.folha.custo.funcao': 'Função',
    'dp.folha.custo.referencia': 'Período de referência',
    'dp.folha.custo.porPeriodo': 'Proventos por período',
    'dp.folha.custo.barra': '{{rotulo}}, custo total {{valor}}, {{pessoas}} pessoas',
    'dp.folha.custo.vazio': 'A folha ainda não está no Hub. Mande o arquivo pela tela de Arquivos.',
    'dp.folha.custo.periodosForaDaMedia': 'Custo médio fora da média dos três períodos anteriores, em mais de {{desvio}}: {{periodos}}.',
    'dp.folha.regra.inss': 'INSS do empregado na faixa',
    'dp.folha.regra.fgts': 'FGTS sobre a base',
    'dp.folha.esperado.inss': 'A tabela progressiva do INSS sobre a base da folha',
    'dp.folha.esperado.fgts': 'O percentual do FGTS sobre a base da folha',
    'dp.folha.detalhe.inss': 'INSS do empregado',
    'dp.folha.detalhe.fgts': 'FGTS',
    'dp.folha.detalhe.fgtsAprendiz': 'FGTS do aprendiz',
    'dp.folha.regra.periculosidade': 'Periculosidade do motorista do combustível',
    'dp.folha.esperado.periculosidade': 'O percentual sobre o salário de quem dirigiu o tanque de combustível no mês',
    'dp.folha.detalhe.periculosidade': 'Periculosidade do combustível',
    'dp.folha.detalhe.periculosidadeSemExposicao': 'Periculosidade sem dirigir o combustível',
    'dp.folha.kpi.diferencaAberta': 'Diferença em aberto',
    'dp.folha.kpi.diferencaAbertaDica': '{{valor}} de diferença nos alertas que ninguém tratou',
    'dp.folha.kpi.diferencaJustificada': 'Diferença justificada',
    'dp.folha.kpi.diferencaJustificadaDica': '{{valor}} que o DP olhou e explicou',
    'dp.folha.kpi.corrigido': 'Corrigido na folha',
    'dp.folha.kpi.corrigidoDica': '{{valor}} de diferença que sumiu da folha depois da correção no Protheus',
    'dp.folha.custo.encargos': 'Encargos',
    'dp.folha.custo.custoTotal': 'Custo total',
    'dp.folha.custo.faturamento': 'Faturamento',
    'dp.folha.custo.folhaSobreFaturamento': 'Folha sobre o faturamento',
    'dp.folha.custo.semFaturamento': 'Sem faturamento',
    'dp.folha.custo.informeOFaturamento': 'Informe o faturamento do mês para ver a proporção',
    'dp.folha.custo.meta': 'Meta da diretoria até {{meta}}',
    'dp.folha.custo.metaSobre': 'Meta até {{meta}}, sobre {{valor}}',
    'dp.folha.custo.encargosEstimados': 'Estimados em {{pct}} dos proventos',
    'dp.folha.custo.encargosDasVerbas': 'Somados das verbas de encargo da folha',
    'dp.folha.custo.desvioDica': '{{desvio}} contra a média dos três anteriores',
    'dp.folha.custo.mediaAnteriorDica': 'Custo médio {{medio}}, média dos três anteriores {{valor}}',
    'dp.folha.custo.periodo': 'Período',
    'dp.folha.custo.conferencia': 'Conferência',
    'dp.folha.custo.semConferencia': 'Não conferido',
    'dp.folha.custo.abertosEmValor': '{{n}} abertos, {{valor}}',
    'dp.folha.custo.corrigidoEmValor': '{{n}} corrigidos, {{valor}}',
    'dp.folha.custo.informarFaturamento': 'Informar faturamento',
    'dp.folha.custo.faturamentoTitulo': 'Faturamento do mês',
    'dp.folha.custo.faturamentoExplica': 'O total faturado pela filial no mês. O Hub divide o custo da folha com encargos por ele e compara com a meta da diretoria. Informar de novo o mesmo mês e filial corrige o valor.',
    'dp.folha.custo.valor': 'Faturamento em reais',
    'dp.folha.custo.observacao': 'Observação',
    'dp.folha.custo.removerFaturamento': 'Remover',
    'dp.folha.custo.avisoEncargoEstimado': 'Os encargos patronais estão estimados em {{pct}} dos proventos. Configure as verbas de encargo em Parâmetros para o Hub somar o valor real da folha.',
    'dp.folha.custo.avisoEncargoVerbas': 'Os encargos patronais vêm das verbas de encargo da folha configuradas em Parâmetros.',
    'dp.folha.custo.periodosAcimaDaMeta': 'Folha acima da meta de {{meta}} do faturamento: {{periodos}}.',
    'dp.folha.custo.sobreFaturamento': 'Sobre o faturamento',
    'dp.folha.custo.pendente': 'Pendente',
    'dp.folha.custo.pessoasCurto': 'Pessoas',
    'dp.folha.custo.faturamentoFaltando': 'Para a folha sobre o faturamento de {{rotulo}}, falta informar o faturamento de: {{filiais}}.',
  },
  en: {
    'dp.folha.titulo': 'Payroll check',
    'dp.folha.aba.conferencia': 'Check',
    'dp.folha.aba.custo': 'Payroll cost',
    'dp.folha.explica': 'HR sends the payroll through the Files screen, the rules compare it with what the Hub knows, and only what differs becomes an alert. Fix it in Protheus and run again, or justify it here. Closing records what was checked and by whom. Vacation averages, thirteenth salary and notice stay manual in Payroll routines.',
    'dp.folha.kpi.aberto': 'Open alerts',
    'dp.folha.kpi.justificado': 'Justified',
    'dp.folha.kpi.resolvido': 'Resolved',
    'dp.folha.kpi.semVerbas': 'Rules without pay codes',
    'dp.folha.rodar': 'Run rules',
    'dp.folha.rodou': 'Rules run: {{novos}} new, {{resolvidos}} resolved, {{reabertos}} reopened.',
    'dp.folha.fecharDica': 'Closes the check and records who closed it. {{n}} open alerts stay on record as they are.',
    'dp.folha.semFolha': 'The {{rotulo}} payroll is not in the Hub. Send the file through the Files screen.',
    'dp.folha.abrirArquivos': 'Open Files',
    'dp.folha.filiaisSemFolha': 'No payroll for this period, and out of the rules: {{filiais}}.',
    'dp.folha.folhaMudou': 'The payroll was imported after the last run. Run the rules again.',
    'dp.folha.fechada': 'Closed by {{quem}} on {{quando}}, with {{abertos}} open alerts and {{justificados}} justified.',
    'dp.folha.sistema': 'system',
    'dp.folha.naoRodou': 'The rules for this pay period have not run yet.',
    'dp.folha.todasComVerbas': 'All rules have pay codes configured.',
    'dp.folha.configurar': 'Configure',
    'dp.folha.semVerbasDica': 'The pay codes are missing from the parameters. Until then, the rule gives no alert.',
    'dp.folha.parcialDica': 'The rule runs in part: some pay codes are missing from the parameters.',
    'dp.folha.semVerbasSemKey': 'Not configured',
    'dp.folha.abertoUm': '1 open',
    'dp.folha.abertos': '{{n}} open',
    'dp.folha.conferidoUm': '1 checked',
    'dp.folha.conferidos': '{{n}} checked',
    'dp.folha.contagemDaRegra': '{{justificados}} justified, {{resolvidos}} resolved',
    'dp.folha.quadroDaFilial': '{{filial}}, headcount {{quadro}}, payroll {{folha}}',
    'dp.folha.por': 'By {{quem}}',
    'dp.folha.semPessoa': 'No person',
    'dp.folha.valorOculto': 'Hidden',
    'dp.folha.valorOcultoDica': 'The value only shows for those who can see HR sensitive data',
    'dp.folha.justificar': 'Justify',
    'dp.folha.editarJustificativa': 'Edit the justification',
    'dp.folha.reabrir': 'Reopen the alert',
    'dp.folha.justificativa': 'Justification',
    'dp.folha.justificarTitulo': 'Justify the alert for {{nome}}',
    'dp.folha.justificarExplica': 'The justification stays on the alert, survives the next runs and does not go to the audit trail. Do not write health reasons.',
    'dp.folha.col.pessoa': 'Person',
    'dp.folha.col.regra': 'Rule',
    'dp.folha.col.esperado': 'Expected',
    'dp.folha.col.naFolha': 'On payroll',
    'dp.folha.col.diferenca': 'Difference',
    'dp.folha.col.situacao': 'Status',
    'dp.folha.col.acoes': 'Actions',
    'dp.folha.situacao.aberto': 'Open',
    'dp.folha.situacao.justificado': 'Justified',
    'dp.folha.situacao.resolvido': 'Resolved',
    'dp.folha.situacaoRegra.ok': 'No alert',
    'dp.folha.situacaoRegra.alertas': 'With alert',
    'dp.folha.situacaoRegra.sem_verbas': 'Pay codes not configured',
    'dp.folha.situacaoRegra.sem_folha': 'No payroll',
    'dp.folha.situacaoRegra.sem_base': 'No source',
    'dp.folha.situacaoRegra.nao_rodada': 'Not run',
    'dp.folha.regra.verba_proibida': 'Pay code that cannot be on the payroll',
    'dp.folha.regra.adiantamento': 'Advance with the matching deduction',
    'dp.folha.regra.coparticipacao': 'Copayment equal to the health plan',
    'dp.folha.regra.horas_extras': 'Overtime equal to the journey',
    'dp.folha.regra.afastados_desligados': 'Terminated, on leave and returned',
    'dp.folha.regra.quadro': 'Who is on the payroll and who is on the headcount',
    'dp.folha.regra.bonus_adicionais': 'Bonus and allowances equal to the calculation',
    'dp.folha.regra.descontos_administrativos': 'Fine and claim deductions',
    'dp.folha.regra.custo_medio': 'Cost within the average',
    'dp.folha.esperado.verba_proibida': 'Nobody with the pay code',
    'dp.folha.esperado.adiantamento': 'Credit equal to debit, per person',
    'dp.folha.esperado.coparticipacao': 'The month invoice in Health plan',
    'dp.folha.esperado.horas_extras': 'The journey of the pay period, 16th to 15th',
    'dp.folha.esperado.afastados_desligados': 'The termination and Absences',
    'dp.folha.esperado.quadro': 'The Protheus active employee base',
    'dp.folha.esperado.bonus_adicionais': 'The calculation in Bonus and allowances',
    'dp.folha.esperado.descontos_administrativos': 'Driver Fines and Claims',
    'dp.folha.esperado.custo_medio': 'The average of the previous three periods',
    'dp.folha.detalhe.adiantamento': 'Advance',
    'dp.folha.detalhe.coparticipacao': 'Copayment',
    'dp.folha.detalhe.he50': 'Overtime 50%',
    'dp.folha.detalhe.he100': 'Overtime 100%',
    'dp.folha.detalhe.demitido': 'Terminated before the period, with salary',
    'dp.folha.detalhe.afastado': 'On leave the whole period, with salary',
    'dp.folha.detalhe.voltou': 'Back at work, without salary',
    'dp.folha.detalhe.semProvento': 'On the headcount, no earnings on payroll',
    'dp.folha.detalhe.foraDoQuadro': 'On payroll, off the headcount',
    'dp.folha.detalhe.operador_hectare': 'Operator bonus',
    'dp.folha.detalhe.adicional_prancha': 'Flatbed allowance',
    'dp.folha.detalhe.adicional_sinistro': 'Claim allowance',
    'dp.folha.detalhe.adicional_manobra': 'Maneuver allowance',
    'dp.folha.detalhe.adicional_eixos': 'Axle allowance',
    'dp.folha.detalhe.descontoMulta': 'Fine deduction',
    'dp.folha.detalhe.descontoSinistro': 'Claim deduction',
    'dp.folha.detalhe.semFuncao': 'No role',
    'dp.folha.custo.proventos': 'Earnings',
    'dp.folha.custo.pessoas': 'People with earnings',
    'dp.folha.custo.medio': 'Average cost',
    'dp.folha.custo.mediaAnterior': 'Average of the previous three',
    'dp.folha.custo.desvio': 'Deviation',
    'dp.folha.custo.situacao': 'Status',
    'dp.folha.custo.foraDaMedia': 'Off the average',
    'dp.folha.custo.semMedia': 'No average',
    'dp.folha.custo.funcao': 'Role',
    'dp.folha.custo.referencia': 'Reference period',
    'dp.folha.custo.porPeriodo': 'Earnings by period',
    'dp.folha.custo.barra': '{{rotulo}}, {{valor}}, {{pessoas}} people',
    'dp.folha.custo.vazio': 'The payroll is not in the Hub yet. Send the file through the Files screen.',
    'dp.folha.custo.periodosForaDaMedia': 'Average cost off the average of the previous three periods, by more than {{desvio}}: {{periodos}}.',
    'dp.folha.regra.inss': 'Employee INSS within the bracket',
    'dp.folha.regra.fgts': 'FGTS on the base',
    'dp.folha.esperado.inss': 'The progressive INSS table on the payroll base',
    'dp.folha.esperado.fgts': 'The FGTS rate on the payroll base',
    'dp.folha.detalhe.inss': 'Employee INSS',
    'dp.folha.detalhe.fgts': 'FGTS',
    'dp.folha.detalhe.fgtsAprendiz': 'Apprentice FGTS',
    'dp.folha.regra.periculosidade': 'Hazard pay of the fuel truck driver',
    'dp.folha.esperado.periculosidade': 'The rate on the salary of whoever drove the fuel tanker in the month',
    'dp.folha.detalhe.periculosidade': 'Fuel hazard pay',
    'dp.folha.detalhe.periculosidadeSemExposicao': 'Hazard pay without driving the fuel tanker',
    'dp.folha.kpi.diferencaAberta': 'Open difference',
    'dp.folha.kpi.diferencaAbertaDica': '{{valor}} of difference in alerts nobody handled',
    'dp.folha.kpi.diferencaJustificada': 'Justified difference',
    'dp.folha.kpi.diferencaJustificadaDica': '{{valor}} that HR reviewed and explained',
    'dp.folha.kpi.corrigido': 'Fixed on payroll',
    'dp.folha.kpi.corrigidoDica': '{{valor}} of difference gone from the payroll after the fix in Protheus',
    'dp.folha.custo.encargos': 'Charges',
    'dp.folha.custo.custoTotal': 'Total cost',
    'dp.folha.custo.faturamento': 'Revenue',
    'dp.folha.custo.folhaSobreFaturamento': 'Payroll over revenue',
    'dp.folha.custo.semFaturamento': 'No revenue',
    'dp.folha.custo.informeOFaturamento': 'Enter the month revenue to see the ratio',
    'dp.folha.custo.meta': 'Board target up to {{meta}}',
    'dp.folha.custo.metaSobre': 'Target up to {{meta}}, over {{valor}}',
    'dp.folha.custo.encargosEstimados': 'Estimated at {{pct}} of earnings',
    'dp.folha.custo.encargosDasVerbas': 'Summed from the payroll charge codes',
    'dp.folha.custo.desvioDica': '{{desvio}} against the previous three average',
    'dp.folha.custo.mediaAnteriorDica': 'Average cost {{medio}}, previous three average {{valor}}',
    'dp.folha.custo.periodo': 'Period',
    'dp.folha.custo.conferencia': 'Check',
    'dp.folha.custo.semConferencia': 'Not checked',
    'dp.folha.custo.abertosEmValor': '{{n}} open, {{valor}}',
    'dp.folha.custo.corrigidoEmValor': '{{n}} fixed, {{valor}}',
    'dp.folha.custo.informarFaturamento': 'Enter revenue',
    'dp.folha.custo.faturamentoTitulo': 'Month revenue',
    'dp.folha.custo.faturamentoExplica': 'The total the branch billed in the month. The Hub divides the payroll cost with charges by it and compares with the board target. Entering the same month and branch again fixes the value.',
    'dp.folha.custo.valor': 'Revenue in reais',
    'dp.folha.custo.observacao': 'Note',
    'dp.folha.custo.removerFaturamento': 'Remove',
    'dp.folha.custo.avisoEncargoEstimado': 'Employer charges are estimated at {{pct}} of earnings. Set the charge pay codes in Parameters for the Hub to sum the real payroll value.',
    'dp.folha.custo.avisoEncargoVerbas': 'Employer charges come from the payroll charge codes set in Parameters.',
    'dp.folha.custo.periodosAcimaDaMeta': 'Payroll above the {{meta}} revenue target: {{periodos}}.',
    'dp.folha.custo.sobreFaturamento': 'Over revenue',
    'dp.folha.custo.pendente': 'Pending',
    'dp.folha.custo.pessoasCurto': 'People',
    'dp.folha.custo.faturamentoFaltando': 'For the {{rotulo}} payroll over revenue, the revenue is still missing for: {{filiais}}.',
  },
  es: {
    'dp.folha.titulo': 'Verificación de la nómina',
    'dp.folha.aba.conferencia': 'Verificación',
    'dp.folha.aba.custo': 'Costo de nómina',
    'dp.folha.explica': 'El DP envía la nómina por la pantalla de Archivos, las reglas la comparan con lo que el Hub sabe y solo lo que difiere se vuelve alerta. Corrija en Protheus y ejecute de nuevo, o justifique aquí. Cerrar registra lo verificado y por quién. Promedios de vacaciones, aguinaldo y aviso siguen manuales en Rutinas de nómina.',
    'dp.folha.kpi.aberto': 'Alertas abiertas',
    'dp.folha.kpi.justificado': 'Justificadas',
    'dp.folha.kpi.resolvido': 'Resueltas',
    'dp.folha.kpi.semVerbas': 'Reglas sin conceptos',
    'dp.folha.rodar': 'Ejecutar reglas',
    'dp.folha.rodou': 'Reglas ejecutadas: {{novos}} nuevas, {{resolvidos}} resueltas, {{reabertos}} reabiertas.',
    'dp.folha.fecharDica': 'Cierra la verificación con el registro de quién cerró. {{n}} alertas abiertas quedan registradas como están.',
    'dp.folha.semFolha': 'La nómina de {{rotulo}} no está en el Hub. Envíe el archivo por la pantalla de Archivos.',
    'dp.folha.abrirArquivos': 'Abrir Archivos',
    'dp.folha.filiaisSemFolha': 'Sin nómina en este período, y fuera de las reglas: {{filiais}}.',
    'dp.folha.folhaMudou': 'La nómina se importó después de la última ejecución. Ejecute las reglas de nuevo.',
    'dp.folha.fechada': 'Cerrada por {{quem}} el {{quando}}, con {{abertos}} alertas abiertas y {{justificados}} justificadas.',
    'dp.folha.sistema': 'sistema',
    'dp.folha.naoRodou': 'Las reglas de este período aún no se ejecutaron.',
    'dp.folha.todasComVerbas': 'Todas las reglas tienen conceptos configurados.',
    'dp.folha.configurar': 'Configurar',
    'dp.folha.semVerbasDica': 'Faltan los códigos de concepto en los parámetros. Hasta entonces, la regla no da alerta.',
    'dp.folha.parcialDica': 'La regla se ejecuta en parte: faltan algunos códigos de concepto en los parámetros.',
    'dp.folha.semVerbasSemKey': 'Falta configurar',
    'dp.folha.abertoUm': '1 abierta',
    'dp.folha.abertos': '{{n}} abiertas',
    'dp.folha.conferidoUm': '1 verificado',
    'dp.folha.conferidos': '{{n}} verificados',
    'dp.folha.contagemDaRegra': '{{justificados}} justificadas, {{resolvidos}} resueltas',
    'dp.folha.quadroDaFilial': '{{filial}}, plantilla {{quadro}}, nómina {{folha}}',
    'dp.folha.por': 'Por {{quem}}',
    'dp.folha.semPessoa': 'Sin persona',
    'dp.folha.valorOculto': 'Oculto',
    'dp.folha.valorOcultoDica': 'El valor solo aparece para quien ve datos sensibles del DP',
    'dp.folha.justificar': 'Justificar',
    'dp.folha.editarJustificativa': 'Editar la justificación',
    'dp.folha.reabrir': 'Reabrir la alerta',
    'dp.folha.justificativa': 'Justificación',
    'dp.folha.justificarTitulo': 'Justificar la alerta de {{nome}}',
    'dp.folha.justificarExplica': 'La justificación queda en la alerta, sobrevive a las próximas ejecuciones y no va al registro de auditoría. No escriba motivos de salud.',
    'dp.folha.col.pessoa': 'Persona',
    'dp.folha.col.regra': 'Regla',
    'dp.folha.col.esperado': 'Esperado',
    'dp.folha.col.naFolha': 'En nómina',
    'dp.folha.col.diferenca': 'Diferencia',
    'dp.folha.col.situacao': 'Situación',
    'dp.folha.col.acoes': 'Acciones',
    'dp.folha.situacao.aberto': 'Abierta',
    'dp.folha.situacao.justificado': 'Justificada',
    'dp.folha.situacao.resolvido': 'Resuelta',
    'dp.folha.situacaoRegra.ok': 'Sin alerta',
    'dp.folha.situacaoRegra.alertas': 'Con alerta',
    'dp.folha.situacaoRegra.sem_verbas': 'Conceptos sin configurar',
    'dp.folha.situacaoRegra.sem_folha': 'Sin nómina',
    'dp.folha.situacaoRegra.sem_base': 'Sin base',
    'dp.folha.situacaoRegra.nao_rodada': 'No ejecutada',
    'dp.folha.regra.verba_proibida': 'Concepto que no puede estar en la nómina',
    'dp.folha.regra.adiantamento': 'Anticipo con el descuento correspondiente',
    'dp.folha.regra.coparticipacao': 'Copago igual al de la aseguradora',
    'dp.folha.regra.horas_extras': 'Horas extras iguales a la jornada',
    'dp.folha.regra.afastados_desligados': 'Despedidos, de baja y quien volvió',
    'dp.folha.regra.quadro': 'Quién está en la nómina y quién en la plantilla',
    'dp.folha.regra.bonus_adicionais': 'Bono y adicionales iguales al cálculo',
    'dp.folha.regra.descontos_administrativos': 'Descuentos de multa y de siniestro',
    'dp.folha.regra.custo_medio': 'Costo dentro del promedio',
    'dp.folha.esperado.verba_proibida': 'Nadie con el concepto',
    'dp.folha.esperado.adiantamento': 'El crédito igual al débito, por persona',
    'dp.folha.esperado.coparticipacao': 'La factura del mes en Plan de salud',
    'dp.folha.esperado.horas_extras': 'La jornada del período, del 16 al 15',
    'dp.folha.esperado.afastados_desligados': 'El despido y las Ausencias',
    'dp.folha.esperado.quadro': 'La base de activos de Protheus',
    'dp.folha.esperado.bonus_adicionais': 'El cálculo en Bono y adicionales',
    'dp.folha.esperado.descontos_administrativos': 'Multas y Siniestros del conductor',
    'dp.folha.esperado.custo_medio': 'El promedio de los tres períodos anteriores',
    'dp.folha.detalhe.adiantamento': 'Anticipo',
    'dp.folha.detalhe.coparticipacao': 'Copago',
    'dp.folha.detalhe.he50': 'Horas extras 50%',
    'dp.folha.detalhe.he100': 'Horas extras 100%',
    'dp.folha.detalhe.demitido': 'Despedido antes del período, con salario',
    'dp.folha.detalhe.afastado': 'De baja todo el período, con salario',
    'dp.folha.detalhe.voltou': 'Volvió al trabajo, sin salario',
    'dp.folha.detalhe.semProvento': 'En la plantilla, sin devengos en la nómina',
    'dp.folha.detalhe.foraDoQuadro': 'En la nómina, fuera de la plantilla',
    'dp.folha.detalhe.operador_hectare': 'Bono del operador',
    'dp.folha.detalhe.adicional_prancha': 'Adicional de plataforma',
    'dp.folha.detalhe.adicional_sinistro': 'Adicional de siniestro',
    'dp.folha.detalhe.adicional_manobra': 'Adicional de maniobra',
    'dp.folha.detalhe.adicional_eixos': 'Adicional de ejes',
    'dp.folha.detalhe.descontoMulta': 'Descuento de multa',
    'dp.folha.detalhe.descontoSinistro': 'Descuento de siniestro',
    'dp.folha.detalhe.semFuncao': 'Sin función',
    'dp.folha.custo.proventos': 'Devengos',
    'dp.folha.custo.pessoas': 'Personas con devengos',
    'dp.folha.custo.medio': 'Costo promedio',
    'dp.folha.custo.mediaAnterior': 'Promedio de los tres anteriores',
    'dp.folha.custo.desvio': 'Desviación',
    'dp.folha.custo.situacao': 'Situación',
    'dp.folha.custo.foraDaMedia': 'Fuera del promedio',
    'dp.folha.custo.semMedia': 'Sin promedio',
    'dp.folha.custo.funcao': 'Función',
    'dp.folha.custo.referencia': 'Período de referencia',
    'dp.folha.custo.porPeriodo': 'Devengos por período',
    'dp.folha.custo.barra': '{{rotulo}}, {{valor}}, {{pessoas}} personas',
    'dp.folha.custo.vazio': 'La nómina aún no está en el Hub. Envíe el archivo por la pantalla de Archivos.',
    'dp.folha.custo.periodosForaDaMedia': 'Costo promedio fuera del promedio de los tres períodos anteriores, en más de {{desvio}}: {{periodos}}.',
    'dp.folha.regra.inss': 'INSS del empleado en el tramo',
    'dp.folha.regra.fgts': 'FGTS sobre la base',
    'dp.folha.esperado.inss': 'La tabla progresiva del INSS sobre la base de la nómina',
    'dp.folha.esperado.fgts': 'El porcentaje del FGTS sobre la base de la nómina',
    'dp.folha.detalhe.inss': 'INSS del empleado',
    'dp.folha.detalhe.fgts': 'FGTS',
    'dp.folha.detalhe.fgtsAprendiz': 'FGTS del aprendiz',
    'dp.folha.regra.periculosidade': 'Peligrosidad del conductor de combustible',
    'dp.folha.esperado.periculosidade': 'El porcentaje sobre el salario de quien condujo el tanque de combustible en el mes',
    'dp.folha.detalhe.periculosidade': 'Peligrosidad del combustible',
    'dp.folha.detalhe.periculosidadeSemExposicao': 'Peligrosidad sin conducir el combustible',
    'dp.folha.kpi.diferencaAberta': 'Diferencia abierta',
    'dp.folha.kpi.diferencaAbertaDica': '{{valor}} de diferencia en alertas que nadie trató',
    'dp.folha.kpi.diferencaJustificada': 'Diferencia justificada',
    'dp.folha.kpi.diferencaJustificadaDica': '{{valor}} que el DP revisó y explicó',
    'dp.folha.kpi.corrigido': 'Corregido en la nómina',
    'dp.folha.kpi.corrigidoDica': '{{valor}} de diferencia que desapareció de la nómina tras la corrección en Protheus',
    'dp.folha.custo.encargos': 'Cargas',
    'dp.folha.custo.custoTotal': 'Costo total',
    'dp.folha.custo.faturamento': 'Facturación',
    'dp.folha.custo.folhaSobreFaturamento': 'Nómina sobre la facturación',
    'dp.folha.custo.semFaturamento': 'Sin facturación',
    'dp.folha.custo.informeOFaturamento': 'Informe la facturación del mes para ver la proporción',
    'dp.folha.custo.meta': 'Meta de la dirección hasta {{meta}}',
    'dp.folha.custo.metaSobre': 'Meta hasta {{meta}}, sobre {{valor}}',
    'dp.folha.custo.encargosEstimados': 'Estimadas en {{pct}} de los devengos',
    'dp.folha.custo.encargosDasVerbas': 'Sumadas de los conceptos de carga de la nómina',
    'dp.folha.custo.desvioDica': '{{desvio}} frente al promedio de los tres anteriores',
    'dp.folha.custo.mediaAnteriorDica': 'Costo promedio {{medio}}, promedio de los tres anteriores {{valor}}',
    'dp.folha.custo.periodo': 'Período',
    'dp.folha.custo.conferencia': 'Verificación',
    'dp.folha.custo.semConferencia': 'Sin verificar',
    'dp.folha.custo.abertosEmValor': '{{n}} abiertas, {{valor}}',
    'dp.folha.custo.corrigidoEmValor': '{{n}} corregidas, {{valor}}',
    'dp.folha.custo.informarFaturamento': 'Informar facturación',
    'dp.folha.custo.faturamentoTitulo': 'Facturación del mes',
    'dp.folha.custo.faturamentoExplica': 'El total facturado por la sucursal en el mes. El Hub divide el costo de la nómina con cargas por él y lo compara con la meta de la dirección. Informar de nuevo el mismo mes y sucursal corrige el valor.',
    'dp.folha.custo.valor': 'Facturación en reales',
    'dp.folha.custo.observacao': 'Observación',
    'dp.folha.custo.removerFaturamento': 'Quitar',
    'dp.folha.custo.avisoEncargoEstimado': 'Las cargas patronales están estimadas en {{pct}} de los devengos. Configure los conceptos de carga en Parámetros para que el Hub sume el valor real de la nómina.',
    'dp.folha.custo.avisoEncargoVerbas': 'Las cargas patronales vienen de los conceptos de carga de la nómina configurados en Parámetros.',
    'dp.folha.custo.periodosAcimaDaMeta': 'Nómina por encima de la meta de {{meta}} de la facturación: {{periodos}}.',
    'dp.folha.custo.sobreFaturamento': 'Sobre la facturación',
    'dp.folha.custo.pendente': 'Pendiente',
    'dp.folha.custo.pessoasCurto': 'Personas',
    'dp.folha.custo.faturamentoFaltando': 'Para la nómina sobre la facturación de {{rotulo}}, falta informar la facturación de: {{filiais}}.',
  },
} as const
